<template>
  <div>
    <b-button @click="showModal">
      Узнай больше
    </b-button>
    <b-modal id="modal-center" ref="myModalRef" hide-footer :title='item.title'>
      <div class="d-block text-center">
        <b-media>
            <img slot="aside" :src="item.img_path" alt="Media Aside" />
            <p class="spec"> <strong>Специализация: </strong> {{ item.spec }} </p>


        </b-media>


        <p><strong>О компании: </strong>{{ item.descr }}</p>
        <br>
        <p class="url" v-if="item.url_en"  @click="hideModal"><strong>Сайт производителя (EN): </strong><a :href='item.url_en' target="_blanc">{{ item.url_en }}</a></p>
        <p class="url" v-if="item.url_ru"  @click="hideModal"><strong>Русскоязычная версия сайта: </strong><a :href='item.url_ru' target="_blanc">{{ item.url_ru }}</a></p>
        <a v-if="item.price" :href="'./price/'+ item.price" download @click="hideModal"> <strong>скачать прайс </strong> </a>
        
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Закрыть</b-btn>
     
    </b-modal>
  </div>
</template>

<script>
export default {
  props:['item'],

  methods: {
    showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    }
  }
};
</script>
<style scoped>
  .media{
    align-items: center;
    flex-wrap: wrap;
  }

  p{
    text-align: justify;
    margin: 5px;
  }


  @media(max-width: 560px){
    .url{
      text-align: center;
    }
  }
</style>
